module.exports = __webpack_public_path__ + "img/coder.c6e57e76.png";